/* eslint-disable max-len */
export default {
    name: 'OperationAddSelectAccount',
    props: ['newOperationState'],
    /**
     * @override
     */
    data() {
        return {
            object: null,
            searchResults: [],
            searchAccountTypeSelected: 0,
            objectAccountSearch: ['Todos', 'Cuenta', 'Interviniente', 'DNI / CIF'],
            objectAccounts: [],
            multiseltIsLoading: false,
            intervenerNoAccounts: false,
            lastSearch: false,
            timeOutSearch: null,
            timeOutSearchTime: 1000
        };
    },
    methods: {
        /**
         * Change selection type ('Todos', 'Cuenta', 'Interviniente', 'DNI / CIF')
         * @param {String} index of select type
         */
        selectSearchType(index) {
            this.searchAccountTypeSelected = index;
            this.objectAccounts = [];
            this.searchResults = [];
            this.object = null;
        },
        /**
         * Listen accounts selector input
         * @param {Object} query of search
         */
        onSearchObjectChange(query) {
            clearTimeout(this.timeOutSearch);
            this.multiseltIsLoading = true;
            this.object = null;
            this.objectAccounts = [];
            this.intervenerNoAccounts = false;
            if (!query) {
                return;
            }
            this.timeOutSearch = setTimeout(() => {
                const cfg = {
                    params: {}
                };
                const q = query.split(' ');
                this.lastSearch = q;
                if (this.searchAccountTypeSelected === 0) {
                    this.newOperationState.intervenerSelected = null;
                    cfg.params['$expand'] = 'interveners,distributor,subdistributor';
                    const searchMethod =
                        q[0] === ''
                            ? this.$accountsService.getAccounts('', cfg)
                            : this.$accountsService.getSearch(JSON.stringify(q), cfg);
                    searchMethod.then(res => {
                        if (this.lastSearch === q) {
                            this.objectAccounts = res.data.accounts;
                            this.multiseltIsLoading = false;
                        }
                    });
                    const searchMethod2 =
                        q[0] === ''
                            ? this.$intervenersService.getInterveners('', cfg)
                            : this.$intervenersService.getSearch(JSON.stringify(q), cfg);
                    searchMethod2.then(res => {
                        if (this.lastSearch === q) {
                            this.searchResults = res.data.interveners;
                            this.intervenerSearchDisplay(true);
                        }
                    });
                }
                if (this.searchAccountTypeSelected === 1) {
                    cfg.params['$expand'] = 'interveners,distributor,subdistributor';
                    const searchMethod =
                        q[0] === ''
                            ? this.$accountsService.getAccounts('', cfg)
                            : this.$accountsService.getSearch(JSON.stringify(q), cfg);
                    searchMethod.then(res => {
                        if (this.lastSearch === q) {
                            this.objectAccounts = [];
                            this.objectAccounts = res.data.accounts;
                            this.multiseltIsLoading = false;
                        }
                    });
                }
                if (this.searchAccountTypeSelected === 2) {
                    this.newOperationState.intervenerSelected = null;
                    const searchMethod =
                        q[0] === ''
                            ? this.$intervenersService.getInterveners('', cfg)
                            : this.$intervenersService.getSearch(JSON.stringify(q), cfg);
                    searchMethod.then(res => {
                        if (this.lastSearch === q) {
                            this.objectAccounts = [];
                            this.searchResults = res.data.interveners;
                            this.intervenerSearchDisplay(true);
                            this.multiseltIsLoading = false;
                        }
                    });
                }
                if (this.searchAccountTypeSelected === 3) {
                    this.newOperationState.intervenerSelected = null;
                    cfg.params['$filter'] = `{"document_id":[{"in": "%${q}%" }]}`;
                    this.$intervenersService.getInterveners('', cfg).then(res => {
                        if (this.lastSearch === q) {
                            this.objectAccounts = [];
                            this.searchResults = res.data.interveners;
                            this.intervenerSearchDisplay(true);
                            this.multiseltIsLoading = false;
                        }
                    });
                }
            }, this.timeOutSearchTime);
        },

        /**
         * @param {Object} intervener selected on search
         */
        onSelectSearch(intervener) {
            this.objectAccounts = [];
            const lastname2 = intervener.lastname_2 ? ` ${intervener.lastname_2}` : '';
            this.newOperationState.intervenerSelected = `${intervener.lastname_1}${lastname2} ${intervener.name}`;
            this.newOperationState.intervenerSelected += intervener.document_id ? ` - ${intervener.document_id}` : '';
            this.newOperationState.employee = intervener.is_employed;

            const cfg = {
                params: {
                    $expand: 'account_interveners'
                }
            };
            this.$intervenersService.getIntervenerParticipantAccounts(intervener.uuid, cfg).then(res => {
                this.intervenerNoAccounts = false;
                if (res.data.intervener_accounts.length) {
                    res.data.intervener_accounts.forEach(element => {

                        element.account_interveners = element.account_interveners.map(int => {
                            int.account_roles = int.account_roles.map(role => {
                                const newRole = role.account_intervener_role;
                                return newRole;
                            });
                            return int;
                        });
                        element.account_data.interveners = element.account_interveners;

                        this.objectAccounts.push(element.account_data);
                    });
                } else {
                    this.intervenerNoAccounts = true;
                }
            });
        },
        /**
         * Set displayName in option Multiselect
         * @param {Boolean} showDocument show or not docuemnt on search display
         */
        intervenerSearchDisplay(showDocument = false) {
            this.searchResults.forEach(intervener => {
                const lastname2 = intervener.lastname_2 ? ` ${intervener.lastname_2}` : '';
                intervener.displayName = `${intervener.lastname_1}${lastname2} ${intervener.name}`;
                if (showDocument) {
                    intervener.displayName += intervener.document_id ? ` - ${intervener.document_id}` : '';
                }
            });
        },
        /**
         * Set displayName in option Multiselect
         */
        accountSearchDisplay() {
            this.searchResults = this.searchResults.filter(element => {
                element.displayName = `${element.id_object || ''} - ${element.uuid}`;
                return element.uuid !== this.newOperationState.account.uuid;
            });
        },
        /**
         * @param {Object} accountSelected account selected
         */
        onSelectAccount(accountSelected) {
            this.newOperationState.account = accountSelected;
            this.newOperationState.account_patrimony = [];
            this.newOperationState.operationStep++;
            this.searchResults = [];

            // Hago una llamada al get de la cuenta para pillar uuid de distribuidor y subdistribuidor-> ¿Cambiar a extend?
            this.$accountsService.getAccountsByUUId(accountSelected.uuid, {}).then(res => {
                this.newOperationState.account.uuid_distributor = res.data.account.uuid_distributor;
                this.newOperationState.account.uuid_subdistributor = res.data.account.uuid_subdistributor;
                this.newOperationState.account_patrimony = res.data.account.account_patrimony || [];
            });
            this.newOperationState.positionsLoaded = false;
            this.newOperationState.account.products = [];

            this.$accountsService
                .getAccountPositions(accountSelected.uuid, {})
                .then(res => {
                    this.newOperationState.account.patrimony = 0;

                    res.data.account_positions.forEach(element => {
                        const key_product = element.key_product;
                        this.newOperationState.account.products[key_product] = {};
                        this.newOperationState.account.products[key_product].shares = element.shares;
                        this.newOperationState.account.products[key_product].net_asset_value = element.net_asset_value;
                        this.newOperationState.account.products[key_product].net_asset_value_date =
                            element.net_asset_value_date;
                        this.newOperationState.account.products[key_product].positions = element.current_amount;
                        this.newOperationState.account.patrimony += Number(element.current_amount);
                    });

                    this.newOperationState.keyAddOperation++;
                })
                .finally(() => {
                    this.newOperationState.positionsLoaded = true;
                    this.newOperationState.keyAddOperation++;
                });

            this.$accountsService.getAccountBankAccounts(accountSelected.uuid, {}).then(res => {
                // this.newOperationState.account.bankAccounts = res.data.bank_accounts.filter(ba => ba.is_validated);
                this.newOperationState.account.bankAccounts = res.data.bank_accounts;
                const fake = { iban_code: 'Nueva cuenta', is_fake: true };
                this.newOperationState.account.bankAccounts.push(fake);
            });
        },
        /**
         * Show account interveners
         * @param {Number} index of account to show
         */
        showAccountInterveners(index) {
            this.$bvModal.show(`modalShowAccountInterveners-${index}`);
        },
        /**
         * Show account interveners
         * @param {Number} index of account to show
         */
        hideAccountInterveners(index) {
            this.$bvModal.hide(`modalShowAccountInterveners-${index}`);
        }
    },
    /**
     * @override
     */
    async mounted() {
        if (this.newOperationState.isEdition) {
            this.objectAccounts.push(this.newOperationState.account);
        }

        if (this.$route.query.uuid) {
            try {
                if (this.$route.query.type === 'intervener') {
                    this.searchAccountTypeSelected = 2;
                    const q = [];
                    q[0] = this.$route.query.uuid;
                    const res = await this.$intervenersService.getSearch(JSON.stringify(q), {});
                    this.object = res.data.interveners[0];
                    this.searchResults = res.data.interveners;
                    this.intervenerSearchDisplay(true);
                    this.onSelectSearch(this.object);
                } else if (this.$route.query.type === 'account') {
                    this.searchAccountTypeSelected = 1;
                    const q = [];
                    q[0] = this.$route.query.uuid;
                    const cfg = {
                        params: {}
                    };
                    cfg.params['$expand'] = 'interveners';
                    const res = await this.$accountsService.getSearch(JSON.stringify(q), cfg);
                    this.object = res.data.accounts[0];
                    this.objectAccounts = res.data.accounts;
                    this.searchResults = res.data.accounts;
                    this.accountSearchDisplay();
                    this.onSelectAccount(res.data.accounts[0]);
                } else if (this.$route.query.type === 'periodic' && !this.newOperationState.periodicInfoLoaded) {
                    this.searchAccountTypeSelected = 1;
                    const res = await this.$operationsService.getOperationsByUUId(this.$route.query.uuid, {});
                    const q = [];
                    q[0] = res.data.operation.account_id;
                    const cfg = {
                        params: {}
                    };
                    cfg.params['$expand'] = 'interveners';
                    const res2 = await this.$accountsService.getSearch(JSON.stringify(q), cfg);
                    this.object = res2.data.accounts[0];
                    this.objectAccounts = res2.data.accounts;
                    this.searchResults = res2.data.accounts;
                    this.accountSearchDisplay();
                    this.onSelectAccount(res2.data.accounts[0]);

                }
            } catch (error) {
                console.error(error);
            }
        }
    }
};
